import { InjectionToken } from '@angular/core';
import { ErrorResponse } from '@apollo/client/link/error';

export abstract class BaseErrorHandler {
  protected duration = 5000;
  abstract handleError(error: ErrorResponse);
}

export const GRAPHQL_ERROR_HANDLERS = new InjectionToken<BaseErrorHandler[]>('graphql.config');
